import { DropdownList } from "react-widgets";
import { useSetState } from "react-use";
import React, { useState } from "react";
import Select from "react-select";

import * as tips from "../../services/FieldsTips";
import Label from "./Label";
import ChannelSelect from "./channelSelect";
import tree from "../../services/tree";

export default function Fields(props) {
  const { selectedFields, updateSelectedFields } = props;

  const { id } = props;

  const [fieldsLists, setFieldsLists] = useSetState({
    channels: tree.channels,
    sources: [],
    mediums: [],
  });

  // console.log(selectedFields);

  const [tempMediums, setTempMediums] = useState([]);

  const { channels, sources, mediums } = fieldsLists;

  const handleChangeChannel = (channel) => {
    updateSelectedFields({ channel: channel.value });
    setFieldsLists({ sources: channel.sources });
  };

  const handleChangeSource = (source) => {
    updateSelectedFields({ source: source.value });
    setFieldsLists({ mediums: source.mediums });
  };

  const handleChangeMedium = (medium) => {
    updateSelectedFields({ medium: medium });
  };

  const handleCreateMedium = (newMedium) => {
    setTempMediums([newMedium]);
    handleChangeMedium(newMedium);
  };

  const handleChangeContent = (event) => {
    updateSelectedFields({ content: event.target.value.replace(" ", "") });
  };
  const handleChangeCustomUrl = (event) => {
    updateSelectedFields({
      customUrl: event.target.value.replace(/[ .]/g, "-"),
    });
  };

  return (
    <>
      <div className="required-fields-container">
        <ChannelSelect
          channels={channels}
          handleSelectChannel={handleChangeChannel}
        />

        <div className="field-container">
          <Label
            name="Source"
            tip={tips.sourceTip}
            htmlFor={id + "sourceField"}
          />
          <Select
            id={id + "sourceField"}
            placeholder="Source"
            onChange={handleChangeSource}
            getOptionLabel={(source) => (
              <span key={source.value} value={source.value}>
                {source.value}
              </span>
            )}
            options={[...sources]}
          />
        </div>

        <div className="field-container">
          <Label
            name="Medium"
            tip={tips.mediumTip}
            htmlFor={id + "mediumField"}
          />
          <DropdownList
            id={id + "mediumField"}
            allowCreate="onFilter"
            value={selectedFields.medium}
            data={[...mediums.map((d) => d.value), ...tempMediums]}
            messages={{
              createOption: (value, searchTerm) =>
                `Usar medium '${searchTerm}'`,
              emptyList: "Não há mediums prontos, mas você pode criar o seu!",
            }}
            onChange={handleChangeMedium}
            onCreate={handleCreateMedium}
          />
        </div>
      </div>

      <div className="optional-fields-container">
        <div className="field-container">
          <Label
            name="Content (Opcional)"
            tip={tips.contentTip}
            htmlFor={id + "contentField"}
          />
          <input
            id={id + "contentField"}
            title={`Nome da Comunidade ou Grupo do Linkedin sem espaços.`}
            type="text"
            className="form-control"
            value={selectedFields.content}
            placeholder="Ex: copy-personalizada-1"
            onChange={handleChangeContent}
          />
        </div>

        <div className="field-container">
          <Label
            name="URL personalizada (Opcional)"
            tip={tips.customUrlTip}
            htmlFor={id + "customUrlField"}
          />
          <input
            id={id + "customUrlField"}
            title={`Nome pro link. ex: byintera.in/sugestao`}
            type="text"
            className="form-control"
            value={selectedFields.customUrl}
            placeholder="Ex: quintoandar-data"
            onChange={handleChangeCustomUrl}
          />
        </div>
      </div>
    </>
  );
}
